export default "__VITE_ASSET__B7PVbfON__"